const TABS = [
  { title: 'Embajadores', type: 'VerificationRequests' },
  { title: 'Tiendas', type: 'StoreRequests' },
  { title: 'Reclamo de Páginas', type: 'PageClaimRequests' },
];

export default TABS;
